import pdfPopupElement from './index.vue';
var instances = [],
	seed = 1;
export default class pdfPopup {

	constructor(options) {
        const {
            Vue
        } = options || {};
        this.Vue = Vue;
        this.pdfPopupConstructor = this.Vue.extend(pdfPopupElement);
    }

	render(options) {
		return this.createCustomElement(Object.assign({
			pdfUrl:'',
		}, options));
	}

	createCustomElement(options) {
		const {
            onConfirm = () => {},
            onCancel = () => {}
		} = options;
		const instance = this.initPdfPopup();
		document.body.appendChild(instance.$el);
		this.Vue.nextTick(() => {
			instance.render(options);
		});
		instances.push(instance);
		instance.$on("onConfirm", res => {
			this.destroyPdfPopup(instance);
			if(typeof onConfirm === 'function') {
				onConfirm(res || '');
			}
        });
        instance.$on("onCancel", res => {
			this.destroyPdfPopup(instance);
			if(typeof onCancel === 'function') {
				onCancel(res || '');
			}
		});
	}

	initPdfPopup() {
		const id = `action${seed++}`;
		const instance = new this.pdfPopupConstructor({
			el: document.createElement('div')
		});
		instance.id = id;
		instance.zIndex += seed;
		return instance;
	}

	destroyPdfPopup(instance) {
		if(!instance) {
			return;
		}
		setTimeout(() => {
            try {
				const index = instances.findIndex(inst => instance.id === inst.id);
				instances.splice(index, 1);
				instance.$destroy();
				document.body.removeChild(instance.$el);
            } catch (error) {
                console.log('remove style error');
            }
		}, 200)
	}

	close() {
		if(instances.length < 1) {
			return
		}
		const instance = instances[instances.length - 1];
		instance.isShow = false;
		this.destroyPdfPopup(instance);
	}

}